import {Auth} from "aws-amplify";

class AuthService {

    userLogin(username, password, callback) {
        Auth.signIn(username, password).then(response => {
            return callback(null, response);
        })
            .catch(error => {
                console.debug(error);
                return callback(error, null);
            });
    }

    getLoginUserSession(callback) {
        Auth.currentSession().then(response => {
            return callback(null, response);
        }).catch(error => {
            console.debug(error);
            return callback(error, null);
        });
    }

    getUserLatestData(cb){
        Auth.currentAuthenticatedUser({
            bypassCache: true
        }).then(user => {
            console.debug("getLatestData",user);
            return cb(null, user);
        })
            .catch(err => {
                console.debug("getLatestData",err);
                return cb(null, err);
            });
    }

    userLogOut(callback) {
        Auth.signOut().then(() => {
            return callback(null, true);
        }).catch(err => {
            return callback(null, true);
        });
    }

    userChangePassword(oldPassword, newPassword, cb) {
        Auth.currentAuthenticatedUser()
            .then(user => {
                return Auth.changePassword(user, oldPassword, newPassword);
            })
            .then(response => {
                return cb(null, response);
            })
            .catch(error => {
                return cb(error, null);
            });
    }

    userRegister(userData, callback) {
        fetch(process.env.REACT_APP_ENDPOINT + process.env.REACT_APP_URL_MERCHANTONBOARD, {
            method: "POST",
            body: JSON.stringify(userData),
        }).then(response => response.json()).then((response) => {
            console.debug(response);
            if (response.success) {
                callback(null, {
                    status: true,
                    message: "Registration Success."
                });
            } else {
                console.debug("str splits", response.errors[0]["source"]["detail"].split(":"));
                let errorSpilt = response.errors[0]["source"]["detail"].split(":");
                if (errorSpilt.length < 1) {
                    callback(null, {
                        status: false,
                        message: errorSpilt[2]
                    });
                } else {
                    callback(null, {
                        status: false,
                        message: errorSpilt[0]
                    });
                }
            }
        })
            .catch((error) => {
                console.debug(error);
                return callback(error, null);
            });
    }
}

export default AuthService;